import { render, staticRenderFns } from "./PlanBenefitInfo.vue?vue&type=template&id=008b1a57"
import script from "./PlanBenefitInfo.vue?vue&type=script&lang=js"
export * from "./PlanBenefitInfo.vue?vue&type=script&lang=js"
import style0 from "./PlanBenefitInfo.vue?vue&type=style&index=0&id=008b1a57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports